// 引用模板
import index from "../page/index.vue";
const result = () => import("../page/result.vue");
const detail = () => import("../page/detail.vue");
const city = () => import("../page/city.vue");
const calendarPage = () => import("../page/calendarPage.vue");
const newcalendar = () => import("../components/calendar.vue");
const searchCity = () => import("../page/searchCity.vue");
const choosecity = () => import("../components/choosecity.vue");
const lisence = () => import("../page/common/lisence.vue");
const login = () => import("../page/reg_log/login.vue");
const register = () => import("../page/reg_log/register.vue");
const firstLogin = () => import("../page/reg_log/firstLogin.vue");
const registerSuccess = () => import("../page/reg_log/registerSuccess.vue");
const setNewPassWord = () => import("../page/reg_log/setNewPassWord.vue");
const setRegisterPassWord = () =>
  import("../page/reg_log/setRegisterPassWord.vue");
const setNewPassWordEmail = () =>
  import("../page/reg_log/setNewPassWordEmail.vue");
const setPassWord = () => import("../page/reg_log/setPassWord.vue");
const setPassWordEmail = () => import("../page/reg_log/setPassWordEmail.vue");
const nation = () => import("../components/nation.vue");
const detailImgs = () => import("../page/detailInfo/Images.vue");
const contactService = () => import("../page/detailInfo/contactService.vue");
const landlordIntroduce = () => import("../page/landlordIntroduce.vue");
const myInfo = () => import("../page/myInfo.vue");
const comment = () => import("../page/myInfos/comment.vue");
const shareDiscount = () => import("../page/myInfos/shareDiscount.vue");
const stayVocuchers = () => import("../page/voucher/stayVocuchers.vue");
const postVocuchers = () => import("../page/voucher/postVouchers.vue");
const exchangeVouchers = () => import("../page/voucher/exchangeVouchers.vue");
const exchangePost = () => import("../page/voucher/exchangePost.vue");
const keeperVouchers = () => import("../page/voucher/keeperVouchers.vue");
const roomVoucherRules = () => import("../page/voucher/roomVoucherRules.vue");
const voucherDetail = () => import("../page/voucher/voucherDetail.vue");
const cleanRules = () => import("../page/voucher/cleanRules.vue");
const voucher = () => import("../page/voucher/voucherList.vue");
const voucherHistory = () => import("../page/voucher/voucherListHistory.vue");
const pointsExchange = () => import("../page/myInfos/pointsExchange.vue");
const redPacket = () => import("../page/myInfos/redPacket.vue");
const collect = () => import("../page/myInfos/collect.vue");
const accountSetting = () => import("../page/myInfos/accountSetting.vue");
const alibabaCredit = () => import("../page/myInfos/alibabaCredit.vue");
const writeComment = () => import("../page/myInfos/writeComment.vue");
const landlordGuide = () => import("../page/myInfos/landlordGuide.vue");
const newCollectGroup = () => import("../page/myInfos/newCollectGroup.vue");
const collectGroupList = () => import("../page/myInfos/collectGroupList.vue");
const commentDetail = () => import("../page/myInfos/commentDetail.vue");
const aboutUs = () => import("../page/myInfos/aboutUs.vue");
const service = () => import("../page/service.vue");
const map = () => import("../components/map.vue");
const app = () => import("../page/app.vue");
const appNew = () => import("../page/appNew.vue");
const orderStart = () => import("../page/order/orderStart.vue");
const chooseVoucher = () => import("../page/order/chooseVoucher.vue");
const bill = () => import("../page/order/bill.vue");
const chooseBill = () => import("../page/order/chooseBill.vue");
const buySafe = () => import("../page/order/buySafe");
const billRules = () => import("../page/order/billRules.vue");
const addInfo = () => import("../page/order/addInfo.vue");
const chooseOccPerson = () => import("../page/order/chooseOccPerson.vue");
const editOccupantInfo = () => import("../page/order/editOccupantInfo.vue");
const orderDetail = () => import("../page/order/orderDetail.vue");
const orderLine = () => import("../page/order/orderLine.vue");
const orderList = () => import("../page/order/orderList.vue");
const landlordOrderLine = () => import("../page/order/landlordOrderLine.vue");
const waitPay = () => import("../page/order/waitPay.vue");
const orderRenewStart = () => import("../page/order/orderRenewStart.vue");
const detailList = () => import("../page/order/detailList.vue");
const renewDetail = () => import("../page/order/renewDetail.vue");
const pay = () => import("../page/order/pay.vue");
const payTrans = () => import("../page/order/payTrans.vue");
const ordercalendar = () => import("../page/order/newcalendar.vue");
const cancelOrder = () => import("../page/order/cancelOrder.vue");
const priceDetail = () => import("../page/order/priceDetail.vue");
const checkInOldRules = () => import("../page/order/checkInOldRules.vue");
const checkInNewRules = () => import("../page/order/checkInRules.vue");
const chooseNation = () => import("../page/order/chooseNation.vue");
const bookConfirm = () => import("../page/order/bookConfirm.vue");
const bookSuc = () => import("../page/order/bookSuc.vue");
const cashpledgefree = () => import("../page/cashpledgefree");
const occupantInfo = () => import("../page/myInfos/occupantInfo.vue");
const doorLock = () => import("../page/order/doorlock4detailV2.vue");
const safeLy = () => import("../page/order/fk_authentication.vue");
// 房东代金券
const introduce = () => import("../page/toApp/fdCashCoupon/introduce.vue");
const cashCouponRule = () =>
  import("../page/toApp/fdCashCoupon/cashCouponRule.vue");
// 分销返现--分享领券
const shareCoupon = () => import("../page/cashBack/shareCoupon.vue");
const cashBack = () => import("../page/cashBack/cashBack.vue");

// 保险
const insurance_intro = () =>
  import("../page/order/insurance/insurance_intro.vue");
const insurance_oversear_instro = () =>
  import("../page/order/insurance/insurance_oversea_intro.vue");
const landlordMainlandTlRule = () =>
  import("../page/order/insurance/landlordMainlandTlRule.vue");
const landlordOverSeaTlRule = () =>
  import("../page/order/insurance/landlordOverSeaTlRule.vue");
const mainLandTlRule = () =>
  import("../page/order/insurance/mainLandTlRule.vue");
const overSeaTlRule = () => import("../page/order/insurance/overSeaTlRule.vue");
const tlRemaid = () => import("../page/order/insurance/tlRemaid.vue");
const cacelSafe = () => import("../page/order/insurance/cacelSafe.vue");
const operateCash = () => import("../page/order/operateCash.vue");
// 平安保险
const pingAn = () => import("../page/order/insurance/pingAn.vue"); // 住宿意外险
const landlordPingAn = () =>
  import("../page/order/insurance/landlordPingAn.vue"); // 房东财产安全
const landlordHuaTai = () =>
  import("../page/order/insurance/landlordHuaTai.vue"); // 房东华泰
const accidentalInjury = () =>
  import("../page/order/insurance/PNAccidentalInjury.vue"); // 意外伤害
const familyProperty = () =>
  import("../page/order/insurance/PNFamilyProperty.vue"); // 家庭财产
const landlordResponsibility = () =>
  import("../page/order/insurance/PNLandlordResponsibility.vue"); // 附加出租人责任
const housePropertyLoss = () =>
  import("../page/order/insurance/PNHousePropertyLoss.vue"); // 附加出租屋财产过失损坏
const tubeExplosion = () =>
  import("../page/order/insurance/PNTubeExplosion.vue"); // 附加水暖管爆裂损失
const propertyTheft = () =>
  import("../page/order/insurance/PNPropertyTheft.vue"); // 附加家庭财产盗抢损失
const reputationLoss = () =>
  import("../page/order/insurance/PNReputationLoss.vue"); // 附加出租房声誉损失津贴
const rentLoss = () => import("../page/order/insurance/PNRentLoss.vue"); // 附加租金损失
const aiTreatment = () => import("../page/order/insurance/PNAITreatment.vue"); // J003平安附加意外伤害医疗保险
const aiHospitalizationAllowance = () =>
  import("../page/order/insurance/PNAIHospitalizationAllowance.vue"); // J092平安附加意外伤害住院津贴保险
const accidentalDeath = () =>
  import("../page/order/insurance/PNAccidentalDeath.vue"); // Y003平安附加交通工具意外身故保险

const allComments = () => import("../page/detailInfo/allComments.vue");
const renewRules = () => import("../page/order/insurance/renewRules");
const chat = () => import("../page/chat.vue");
const chatList = () => import("../page/chatList.vue");
const systemList = () => import("../page/system.vue");

// 个人中心页-关于小猪耳机页面
const AboutXz = () => import("../page/aboutUs/AboutXz.vue");
const SDKInfo = () => import("../page/aboutUs/SDKInfo.vue");
const Underage = () => import("../page/aboutUs/Underage.vue");
const TermsOfService = () => import("../page/aboutUs/TermsOfService.vue");
const BusinessOperation = () => import("../page/aboutUs/BusinessOperation.vue");
const DisputeSettlement = () => import("../page/aboutUs/DisputeSettlement.vue");
const ticketNotice = () => import("../page/aboutUs/ticketNotice.vue");
const CheckInRule = () => import("../page/aboutUs/CheckInRule.vue");
const Disclaimer = () => import("../page/aboutUs/Disclaimer.vue");
const privacyPolicy = () => import("../page/aboutUs/privacyPolicy.vue");
const CommentRule = () => import("../page/aboutUs/CommentRule.vue");
const autoTest = () => import("../components/safeVerify/autoTest.vue");
const story = () => import("../page/roc/story/index.vue");
const brand = () => import("../page/roc/brand/index.vue");
const travel = () => import("../page/roc/travel/index.vue");
const inn = () => import("../page/roc/inn/index.vue");
const officeLineIndex = () => import("../page/roc/officelineService/index.vue");
const allSites = () => import("../page/roc/officelineService/allSites.vue");
const siteDetail = () => import("../page/roc/officelineService/siteDetail.vue");
const siteMap = () => import("../page/roc/officelineService/map.vue");
const serviceIntroduce = () =>
  import("../page/roc/officelineService/serviceIntroduce.vue");
const serviceIndex = () =>
  import("../page/roc/officelineService/serviceIndex.vue");
const officeLineIndexOwn = () =>
  import("../page/roc/officelineService/indexOwn.vue");
const article = () => import("../page/roc/officelineService/article.vue");
const citySites = () => import("../page/roc/officelineService/citySites.vue");
const vip = () => import("../page/agreement/vip.vue");
const memberIntroduce = () => import("../page/memberVip/introduce.vue");
// const memberIntroduce = () => import('../page/memberVip/index.vue');
const memberRights = () => import("../page/memberVip/vipRights.vue");
const takeNotes = () => import("../page/memberVip/takeNotes.vue");
const aboutvip = () => import("../page/memberVip/about.vue");
const agreement = () => import("../page/memberVip/agree.vue");
const appUp = () => import("../page/appUp.vue");
const appDownload = () => import("../page/appDownload.vue");
const chatRobot = () => import("../page/chatRobot.vue");
// APP im营销；
const imMarker = () => import("../page/toApp/imMarker.vue");
// app下载测试地址
const apptest = () => import("../page/apptest.vue");
const apptest2 = () => import("../page/apptest2.vue");
// 会员返现；
const receiveMethod = () => import("../page/toApp/cashBackMethods.vue");
// 房东直销规则
const fdSaleRule = () => import("../page/agreement/fdSaleRule.vue");
// 向您推荐
const recall = () => import("../page/recall/recall.vue");
// 房客协议退款
const consultRefund = () => import("../page/toApp/refund.vue");
// 房客退订规则
const refundRules = () => import("../page/toApp/refundRules.vue");
const refundRulesShow = () => import("../page/toApp/refundRulesShow.vue");
// 退款进度
const refund = () => import("../page/order/refund.vue");
// 退款详情
const refundDetail = () => import("../page/order/refundDetail.vue");
// 消息v3
const chatV3 = () => import("../page/chatV3.vue");
// 商旅补开发票；
const billList = () => import("../page/bills/billList.vue");
// 商旅发票信息
const billInfo = () => import("../page/bills/billInfo.vue");
// 商旅发票
const billHeaderList = () => import("../page/bills/billHeaderList.vue");
// 商旅发票抬头
const billHeader = () => import("../page/bills/billHeader.vue");
// 商旅发票地址信息
const addressList = () => import("../page/bills/addressList.vue");
// 商旅地址信息
const adressInfo = () => import("../page/bills/adressInfo.vue");
// 商旅发票类型
const billType = () => import("../page/bills/billType.vue");
// 马蜂窝商旅登录
const nestBillLogin = () => import("../page/bills/nestBillLogin.vue");
// 填写发票信息
const billNewCreate = () => import("../page/bills/newCreate.vue");
//

// 邀请/被邀请
const invite = () => import("../page/invite/invite.vue");
const inviteList = () => import("../page/invite/inviteList.vue");
const accept = () => import("../page/invite/accept.vue");

// 小猪房态
const houseState = () => import("../page/houseState.vue");
// app跳转桥页
const bridgePage = () => import("../page/bridgePage.vue");
// 房东任务页
const landlordTask = () => import("../page/landlord/landlordTask.vue");
// APP房东促销lose工单
const promotionSheet = () => import("../page/toApp/landlord/promoteLose.vue");
// 跟价记录仪
const priceList = () => import("../page/toApp/landlord/priceList.vue");
// 跟价详情
const loseDetail = () => import("../page/toApp/landlord/priceDetail.vue");
// 超棒房东介绍页
const BestLandlordDetails = () => import("../page/BestLandlord/details.vue");
// 超棒房东主体页
const BestLandlord = () => import("../page/BestLandlord/index.vue");
// 历史的房东介绍页
const HistoryLandlord = () => import("../page/BestLandlord/landlordDesc.vue");
// 超棒房东的拒绝评选页面
const HistoryCantVote = () => import("../page/BestLandlord/cantvote.vue");
// 超棒房东的历史荣誉页面
const HistoryHonor = () => import("../page/BestLandlord/historicalHonor.vue");
// 超棒房东的入门门槛页面
const LandlordThreshold = () =>
  import("../page/BestLandlord/landlordThreshold.vue");
// 超棒房东的评选页面
const LandlordVote = () => import("../page/BestLandlord/landlordVote.vue");
// 发票V6 发票详情
const billV6Detail = () => import("../page/bills/billV6Detail.vue");
// 开票成功
const billV6Suc = () => import("../page/bills/sumitsuc.vue");
// 经营指导
const manageIndex = () => import("../page/manage/index.vue");
// 经营指导 新版
const manageIndexV2 = () => import("../page/manage/manage.vue");
// 经营指导
const manageDetail = () => import("../page/manage/detail.vue");
// app内嵌协议
const agreementList = () => import("../page/agreementList.vue");
// 砍价
const bargin = () => import("../page/bargain/index.vue");
// 砍价成功
const successBargain = () => import("../page/bargain/success.vue");
const jumpUrl = () => import("../page/jumpUrl.vue");

// 房源推广通
const myHousePromotiom = () => import("../page/promotion/my.vue");
const descriptionPromotiom = () => import("../page/promotion/description.vue");
const createPromotiom = () => import("../page/promotion/create.vue");
const historyPromotiom = () => import("../page/promotion/history.vue");
const questionPromotiom = () => import("../page/promotion/question.vue");
const questionItemPromotiom = () =>
  import("../page/promotion/questionItem.vue");
const agreePromotiom = () => import("../page/promotion/agree.vue");

const test = () => import("../page/test.vue");
// 选择本人 身份认证
const selectRealName = () => import("../page/myInfos/selectRealName.vue");

const cashPolicy = () => import("../page/aboutUs/cashPolicy.vue");

// 学生邀请好友
const inviteStudent = () => import("../page/invite/student/index.vue");
// 邀请列表
const studentList = () => import("../page/invite/student/list.vue");

// 房东活动列表
const landlordList = () => import("../page/landlord/activity/list.vue");
// 房东活动详情
const landlordDetail = () => import("../page/landlord/activity/detail.vue");
// 房东活动列表编辑
const landlordEdit = () => import("../page/landlord/activity/edit.vue");
// 房东活动注意事项
const landlordNotice = () => import("../page/landlord/activity/notice.vue");
// 往期活动
const landlordHistory = () =>
  import("../page/landlord/activity/components/history.vue");
// 报名记录
const landlordRecord = () => import("../page/landlord/activity/record.vue");
// 房东活动报名分享页
const landlordSignup = () => import("../page/landlord/activity/signup.vue");
// app中点评完成页面
const commentComplete = () => import("../page/toApp/commentComplete.vue");

// 给app暂时用，用于app智齿上线，引导老版本app升级，等app老版本强制更新后可删除
const zhiChiGuideUpgrade = () => import("../page/toApp/zhiChiGuideUpgrade.vue");

// 404
const notFound = () => import("../page/404.vue");

// 客服介绍
const serviceIntro = () => import("../page/app/service.vue");
// 房东-自动回复
const autoIm = () => import("../page/toApp/autoIm.vue");
// 房东-im自动回复2期全部自动回复
const autoReply = () => import("../page/toApp/autoReply.vue");
// 房东-巡房小助手
const helpIm = () => import("../page/toApp/help.vue");

/* 微信收付通 - 下 -------------------------------------------------------------------------- */
// 选择主体类型
const selectPerson = () => import("../page/wxPay/selectPerson.vue");

// 填写主体营业执照
const wxBusiness = () => import("../page/wxPay/wxBusiness.vue");

// 填写主体身份证号
const wxPerson = () => import("../page/wxPay/wxPerson.vue");

// 填写主体银行相关信息
const wxAccount = () => import("../page/wxPay/wxAccount.vue");

// 个体工商户or企业【废弃】
const enterprisePay = () => import("../page/wxPay/enterprisePay.vue");

// 微信校验状态
const wxCheck = () => import("../page/wxPay/wxCheck.vue");

// 打款验证状态
const checkStatus = () => import("../page/wxPay/checkStatus.vue");

// 二次验证状态
const checkWxTwo = () => import("../page/wxPay/checkWxTwo.vue");

// 绑定状态接口
const checkResult = () => import("../page/wxPay/checkResult.vue");

/* 微信收付通 - 上 -------------------------------------------------------------------------- */

// 反爬空白页
const cookie = () => import("../page/cookie.vue");

const landlordService = () => import("../page/toApp/landlordService.vue");

// 房东代金券规则
const landlordRule = () => import("../page/voucher/landlordRule.vue");

// 房东代金券规则
const shieldLandlord = () => import("../page/app/shield.vue");

// 一键搬房
const houseMove = () => import("../page/houseMove/index.vue");
// 一键搬房 规则
const houseMoveRule = () => import("../page/houseMove/rule.vue");

// 其他信息
const otherInfo = () => import("../page/otherInfo.vue");

// 管辖机构
const jurisdiction = () => import("../page/jurisdiction.vue");

// 用户满意度
const satisfaction = () => import("../page/satisfaction/index.vue");
// 笔记详情
const noteDetail = () => import("../page/noteDetail.vue");

// 取消原因
const cancelReason = () => import("../page/order/cancel/cancelReason.vue");
// 取消订单
const newCancelOrder = () => import("../page/order/cancel/cancelOrder.vue");
// 房东端供应商列
const supplierOrderList = () => import("../page/supplier/index.vue");
// 房东端供应商订单详情
const supplierOrderDetail = () => import("../page/supplier/detail.vue");
// 房东规则
const appRule = () => import("../page/app/appRule.vue");
// 活动榜单
const highQualityList = () => import("../page/highQualityList/highQualityList")

// 房东规则
const appRuleImg = () => import("../page/app/rule/appRuleImg.vue");

const orderPrint = () => import("../page/order/orderPrint.vue");

const openApp = () => import("../page/app/appOpen.vue");

const hotelDetail = () => import("../page/hotel/hotelDetail.vue");

const bargainMall = () => import("../page/bargainMall/index.vue");

const testShare = () => import("../page/testShare.vue");

// 协议
const bussinessOperation = () =>
  import("../page/agreement/bussinessOperation.vue");
const carefreeZhongAnInsurance = () =>
  import("../page/agreement/carefreeZhongAnInsurance.vue");
const cashPledgeFd = () => import("../page/agreement/cashPledgeFd.vue");
const cashPledgeFk = () => import("../page/agreement/cashPledgeFk.vue");
const cleanServiceAccountRule = () =>
  import("../page/agreement/cleanServiceAccountRule.vue");
const commentRule = () => import("../page/agreement/commentRule.vue");
const couponRule = () => import("../page/agreement/couponRule.vue");
const disclaimer = () => import("../page/agreement/disclaimer.vue");
const disputeSettlemant = () =>
  import("../page/agreement/disputeSettlemant.vue");
const familyInsurance = () => import("../page/agreement/familyInsurance.vue");
const goodLandlordRule = () => import("../page/agreement/goodLandlordRule.vue");
const integral = () => import("../page/agreement/integral.vue");
const intellectualProperty = () =>
  import("../page/agreement/intellectualProperty.vue");
const landlordDetailRule = () =>
  import("../page/agreement/landlordDetailRule.vue");
const landlordManageRule = () =>
  import("../page/agreement/landlordManageRule.vue");
const landlordRules = () => import("../page/agreement/landlordRules.vue");
const persionLandlordRule = () =>
  import("../page/agreement/persionLandlordRule.vue");
const priveayPolicy = () => import("../page/agreement/priveayPolicy.vue");
const tailKangFamilyInsurance = () =>
  import("../page/agreement/tailKangFamilyInsurance.vue");
const termOfService = () => import("../page/agreement/termOfService.vue");
const toBeLandlord = () => import("../page/agreement/toBeLandlord.vue");
const copyrights = () => import("../page/agreement/copyrights.vue");
const aboutUsPolicy = () => import("../page/agreement/aboutUs.vue");
const cleanServiceRule = () => import("../page/agreement/cleanServiceRule.vue");
// 配置路由
export default [
  {
    path: "/",
    name: "index",
    component: index,
    meta: {
      title: "小猪-短租民宿预订首选,独一无二的社交住宿体验"
    }
  },
  {
    path: "/city/",
    name: "city",
    component: city,
    meta: {
      title: "小猪-短租民宿预订首选,独一无二的社交住宿体验"
    }
  },
  {
    path: "/lisence/",
    name: "lisence",
    component: lisence,
    meta: {
      title: "小猪-短租民宿预订首选,独一无二的社交住宿体验"
    }
  },
  {
    path: "/app/",
    name: "app",
    component: app,
    meta: {
      title: "小猪-短租民宿预订首选,独一无二的社交住宿体验"
    }
  },
  {
    path: "/apptest/",
    name: "apptest",
    component: apptest,
    meta: {
      title: "小猪-短租民宿预订首选,独一无二的社交住宿体验"
    }
  },
  {
    path: "/apptest2/",
    name: "apptest2",
    component: apptest2,
    meta: {
      title: "小猪-短租民宿预订首选,独一无二的社交住宿体验"
    }
  },
  {
    path: "/app715019/",
    name: "appNew",
    component: appNew,
    meta: {
      title: "小猪-短租民宿预订首选,独一无二的社交住宿体验"
    }
  },
  {
    path: "/service/",
    name: "service",
    component: service,
    meta: {
      title: "小猪-短租民宿预订首选,独一无二的社交住宿体验"
    }
  },
  {
    path: "/calendarPage",
    name: "calendarPage",
    component: calendarPage
  },
  {
    path: "/newcalendar/",
    name: "newcalendar",
    component: newcalendar
  },
  {
    path: "/choosecity/",
    name: "choosecity",
    component: choosecity,
    meta: {
      title: "小猪-短租民宿预订首选,独一无二的社交住宿体验"
    }
  },
  {
    path: "/login/",
    name: "login",
    component: login,
    meta: {
      title: "小猪-登录"
    }
  },
  {
    path: "/firstLogin",
    name: "firstLogin",
    component: firstLogin,
    meta: {
      title: "注册 - 小猪"
    }
  },
  {
    path: "/register/",
    name: "register",
    component: register,
    meta: {
      title: "小猪-注册"
    }
  },
  {
    path: "/register/setRegisterPassWord",
    name: "setRegisterPassWord",
    component: setRegisterPassWord,
    meta: {
      title: "小猪-注册"
    }
  },
  {
    path: "/nation/",
    name: "nation",
    component: nation,
    meta: {
      title: "小猪-登录"
    }
  },
  {
    path: "/setPassWord/",
    name: "setPassWord",
    component: setPassWord,
    meta: {
      title: "小猪-找回密码"
    }
  },
  {
    path: "/setPassWordEmail/",
    name: "setPassWordEmail",
    component: setPassWordEmail,
    meta: {
      title: "小猪-找回密码"
    }
  },
  {
    path: "/setNewPassWord/",
    name: "setNewPassWord",
    component: setNewPassWord,
    meta: {
      title: "小猪-找回密码"
    }
  },
  {
    path: "/registerSuccess",
    name: "registerSuccess",
    component: registerSuccess,
    meta: {
      title: "注册成功"
    }
  },
  {
    path: "/setNewPassWordEmail/",
    name: "setNewPassWordEmail",
    component: setNewPassWordEmail,
    meta: {
      title: "小猪-找回密码"
    }
  },
  {
    path: "/result/",
    name: "result",
    component: result,
    meta: {
      title: "小猪-短租民宿预订首选,独一无二的社交住宿体验"
    }
  },
  {
    path: "/searchCity",
    name: "searchCity",
    component: searchCity,
    meta: {
      title: "小猪-短租民宿预订首选,独一无二的社交住宿体验"
    }
  },
  {
    path: "/myInfo/",
    name: "myInfo",
    component: myInfo,
    meta: {
      title: "小猪-个人中心"
    }
  },
  {
    path: "/myInfo/comment",
    name: "comment",
    component: comment,
    meta: {
      title: "点评"
    }
  },
  {
    path: "/myInfo/writeComment",
    name: "writeComment",
    component: writeComment,
    meta: {
      title: "填写点评"
    }
  },
  {
    path: "/myInfo/shareDiscount",
    name: "shareDiscount",
    component: shareDiscount,
    meta: {
      title: "分享优惠"
    }
  },
  {
    path: "/myInfo/voucher",
    name: "voucher",
    component: voucher,
    meta: {
      title: "代金券"
    }
  },
  {
    path: "/myInfo/voucherHistory",
    name: "voucherHistory",
    component: voucherHistory,
    meta: {
      title: "历史代金券"
    }
  },
  {
    path: "/myInfo/stayVocuchers",
    name: "stayVouchers",
    component: stayVocuchers,
    meta: {
      title: "住宿代金券"
    }
  },
  {
    path: "/myInfo/voucherDetail",
    name: "voucherDetail",
    component: voucherDetail,
    meta: {
      title: "代金券详情"
    }
  },
  {
    path: "/rule/cleanRules",
    name: "cleanRules",
    component: cleanRules,
    meta: {
      title: "小猪管家代金券"
    }
  },
  {
    path: "/rule/cleanRules",
    name: "cleanRules",
    component: cleanRules,
    meta: {
      title: "小猪管家代金券"
    }
  },
  {
    path: "/myInfo/exchangePost",
    name: "exchangePost",
    component: exchangePost,
    meta: {
      title: "小猪发票包邮券"
    }
  },
  {
    path: "/rule/roomVoucherRules",
    name: "roomVoucherRules",
    component: roomVoucherRules,
    meta: {
      title: "什么是住宿代金券"
    }
  },
  {
    path: "/rule/landlordRule",
    name: "landlordRule",
    component: landlordRule,
    meta: {
      title: "使用说明"
    }
  },
  {
    path: "/app/shieldLandlord",
    name: "shieldLandlord",
    component: shieldLandlord,
    meta: {
      title: "屏蔽房客"
    }
  },
  {
    path: "/myInfo/postVouchers",
    name: "postVocuchers",
    component: postVocuchers,
    meta: {
      title: "邮费抵用券"
    }
  },

  {
    path: "/myInfo/keeperVouchers",
    name: "keeperVouchers",
    component: keeperVouchers,
    meta: {
      title: "小猪管家代金券"
    }
  },
  {
    path: "/myInfo/exchangeVouchers",
    name: "exchangeVouchers",
    component: exchangeVouchers,
    meta: {
      title: "红包兑换代金券"
    }
  },
  {
    path: "/myInfo/pointsExchange",
    name: "pointsExchange",
    component: pointsExchange,
    meta: {
      title: "积分兑换"
    }
  },
  {
    path: "/myInfo/redPacket",
    name: "redPacket",
    component: redPacket,
    meta: {
      title: "红包"
    }
  },
  {
    path: "/myInfo/collect",
    name: "collect",
    component: collect,
    meta: {
      title: "我的收藏"
    }
  },
  {
    path: "/myInfo/accountSetting",
    name: "accountSetting",
    component: accountSetting,
    meta: {
      title: "账号设置"
    }
  },
  {
    path: "/myInfo/alibabaCredit",
    name: "alibabaCredit",
    component: alibabaCredit,
    meta: {
      title: "芝麻信用"
    }
  },
  {
    path: "/myInfo/occupantInfo",
    name: "occupantInfo",
    component: occupantInfo,
    meta: {
      title: "常用入住人"
    }
  },
  {
    path: "/myInfo/landlordGuide",
    name: "landlordGuide",
    component: landlordGuide,
    meta: {
      title: "我想成为房东"
    }
  },
  {
    path: "/myInfo/aboutUs",
    name: "aboutUs",
    component: aboutUs,
    meta: {
      title: "关于小猪"
    }
  },
  {
    path: "/aboutUs/SDKInfo",
    name: "SDKInfo",
    component: SDKInfo,
    meta: {
      title: "小猪平台接入第三方 SDK 目录"
    }
  },
  {
    path: "/myInfo/newCollectGroup",
    name: "newCollectGroup",
    component: newCollectGroup,
    meta: {
      title: "新建收藏"
    }
  },
  {
    path: "/myInfo/collectGroupList",
    name: "collectGroupList",
    component: collectGroupList,
    meta: {
      title: "收藏列表"
    }
  },
  {
    path: "/myInfo/commentDetail",
    name: "commentDetail",
    component: commentDetail,
    meta: {
      title: "点评详情"
    }
  },
  {
    path: "/detail",
    name: "detail",
    component: detail,
    meta: {
      title: "房源详情"
    }
  },
  {
    path: "/landlordIntroduce/:landlordId",
    name: "landlordIntroduce",
    component: landlordIntroduce
  },
  {
    path: "/map",
    name: "map",
    component: map,
    meta: {
      title: "地图"
    }
  },
  {
    path: "/order/orderStart/",
    name: "orderStart",
    component: orderStart,
    meta: {
      title: "开始下单"
    }
  },
  {
    path: "/order/bill",
    name: "bill",
    component: bill,
    meta: {
      title: "开具发票"
    }
  },
  // 资金合规 下单开具发票
  {
    path: "/order/chooseBill",
    name: "chooseBill",
    component: chooseBill,
    meta: {
      title: "开具发票"
    }
  },
  {
    path: "/order/bill/newCreate",
    name: "billNewCreate",
    component: billNewCreate,
    meta: {
      title: "填写发票信息"
    }
  },
  // billV6Suc
  {
    path: "/order/bill/billsuc",
    name: "billV6Suc",
    component: billV6Suc,
    meta: {
      title: "发票提交成功"
    }
  },
  {
    path: "/order/buySafe",
    name: "buySafe",
    component: buySafe,
    meta: {
      title: "预定无忧取消险"
    }
  },
  {
    path: "/order/billRules",
    name: "billRules",
    component: billRules,
    meta: {
      title: "发票须知"
    }
  },
  {
    path: "/order/checkInOldRules",
    name: "checkInRules",
    component: checkInOldRules,
    meta: {
      title: "入住规则"
    }
  },
  {
    path: "/order/checkInNewRules",
    name: "checkInRules",
    component: checkInNewRules,
    meta: {
      title: "入住规则"
    }
  },
  {
    path: "/order/chooseVoucher/",
    name: "chooseVoucher",
    component: chooseVoucher,
    meta: {
      title: "选择代金券"
    }
  },
  {
    path: "/order/ordercalendar/",
    name: "ordercalendar",
    component: ordercalendar,
    meta: {
      title: "小猪日历"
    }
  },
  {
    path: "/order/waitPay/",
    name: "waitPay",
    component: waitPay,
    meta: {
      title: "待支付"
    }
  },
  {
    path: "/order/orderRenewStart/",
    name: "orderRenewStart",
    component: orderRenewStart,
    meta: {
      title: "续订"
    }
  },
  {
    path: "/order/detailList",
    name: "detailList",
    component: detailList,
    meta: {
      title: "续订列表"
    }
  },
  {
    path: "/order/renewRules",
    name: "renewRules",
    component: renewRules,
    meta: {
      title: "续订规则"
    }
  },
  {
    path: "/order/renewDetail",
    name: "renewDetail",
    component: renewDetail,
    meta: {
      title: "续订详情"
    }
  },
  {
    path: "/order/addInfo/",
    name: "addInfo",
    component: addInfo,
    meta: {
      title: "信息补充"
    }
  },
  {
    path: "/order/chooseOccPerson/",
    name: "chooseOccPerson",
    component: chooseOccPerson,
    meta: {
      title: "选择入住人"
    }
  },
  {
    path: "/order/editOccupantInfo/",
    name: "editOccupantInfo",
    component: editOccupantInfo,
    meta: {
      title: "添加入住人"
    }
  },
  {
    path: "/chooseNation",
    name: "chooseNation",
    component: chooseNation,
    meta: {
      title: "选择国家"
    }
  },
  {
    path: "/order/orderDetail/",
    name: "orderDetail",
    component: orderDetail,
    meta: {
      title: "订单详情"
    }
  },
  {
    path: "/order/priceDetail/",
    name: "priceDetail",
    component: priceDetail,
    meta: {
      title: "价格详情"
    }
  },
  {
    path: "/order/pay",
    name: "pay",
    component: pay,
    meta: {
      title: "支付"
    }
  },
  {
    path: "/payTrans",
    name: "payTrans",
    component: payTrans,
    meta: {
      title: "支付宝预授权"
    }
  },
  {
    path: "/order/orderLine/",
    name: "orderLine",
    component: orderLine,
    meta: {
      title: "订单明细"
    }
  },
  {
    path: "/order/cancelOrder/",
    name: "cancelOrder",
    component: cancelOrder,
    mata: {
      title: "取消订单"
    }
  },
  {
    path: "/order/operateCash/",
    component: operateCash,
    meta: {
      title: "押金详情"
    }
  },
  {
    path: "/order/orderList/",
    name: "orderList",
    component: orderList,
    meta: {
      title: "订单列表"
    }
  },
  {
    path: "/order/landlordOrderLine/",
    name: "landlordOrderLine",
    component: landlordOrderLine,
    meta: {
      title: "房东订单详情"
    }
  },
  {
    path: "/order/doorLock/",
    name: "doorLock",
    component: doorLock,
    meta: {
      title: "小猪短租"
    }
  },
  {
    path: "/order/safeLy/",
    name: "safeLy",
    component: safeLy,
    meta: {
      title: "身份验证铸建安全保障"
    }
  },
  {
    path: "/order/cacelSafe/",
    name: "cacelSafe",
    component: cacelSafe,
    meta: {
      title: "取消险详情"
    }
  },
  {
    path: "/order/bookConfirm",
    name: "bookConfirm",
    component: bookConfirm,
    meta: {
      title: "房东待确认"
    }
  },
  {
    path: "/order/bookSuc",
    name: "bookSuc",
    component: bookSuc,
    meta: {
      title: "预订成功"
    }
  },
  {
    path: "/supplier/order",
    name: "supplierOrderList",
    component: supplierOrderList,
    meta: {
      title: "房券订单"
    }
  },
  {
    path: "/supplier/order/detail",
    name: "supplierOrderDetail",
    component: supplierOrderDetail,
    meta: {
      title: "小猪房券订单列表"
    }
  },
  {
    path: "/order/cashpledgefree",
    name: "cashpledgefree",
    component: cashpledgefree,
    meta: {
      title: "有信用免押金"
    }
  },
  {
    path: "/cashCoupon/introduce",
    name: "introduce",
    component: introduce,
    meta: {
      title: "房东代金券"
    }
  },
  {
    path: "/cashCoupon/cashCouponRule",
    name: "cashCouponRule",
    component: cashCouponRule,
    meta: {
      title: "规则必读"
    }
  },
  {
    path: "/rule/insurance_intro/",
    name: "insurance_intro",
    component: insurance_intro,
    meta: {
      title: "住宿旅行意外险"
    }
  },
  {
    path: "/rule/insurance_oversear_instro/",
    name: "insurance_oversear_instro",
    component: insurance_oversear_instro,
    meta: {
      title: "境外旅行意外险"
    }
  },
  {
    path: "/rule/landlordMainlandTlRule/",
    name: "landlordMainlandTlRule",
    component: landlordMainlandTlRule,
    meta: {
      title: "未成年人入住规则"
    }
  },
  {
    path: "/rule/landlordOverSeaTlRule/",
    name: "landlordOverSeaTlRule",
    component: landlordOverSeaTlRule,
    meta: {
      title: "未成年人入住规则"
    }
  },
  {
    path: "/rule/mainLandTlRule/",
    name: "mainLandTlRule",
    component: mainLandTlRule,
    meta: {
      title: "未成年人入住规则"
    }
  },
  {
    path: "/rule/overSeaTlRule/",
    name: "overSeaTlRule",
    component: overSeaTlRule,
    meta: {
      title: "未成年人入住规则"
    }
  },
  {
    path: "/rule/tlRemaid/",
    name: "tlRemaid",
    component: tlRemaid,
    meta: {
      title: "未成年人入住规则"
    }
  },
  {
    path: "/detailInfo/allComments/",
    name: "allComments",
    component: allComments,
    meta: {
      title: "房客点评"
    }
  },
  {
    path: "/detailInfo/contactService",
    name: "contactService",
    component: contactService,
    meta: {
      title: "联系客服"
    }
  },
  {
    path: "/chat/",
    name: "chat",
    component: chat,
    meta: {
      title: "消息"
    }
  },
  {
    path: "/chatList/",
    name: "chatList",
    component: chatV3,
    meta: {
      title: "消息"
    }
  },
  {
    path: "/systemList/",
    name: "systemList",
    component: systemList,
    meta: {
      title: "系统消息"
    }
  },
  {
    path: "/detail/detailImgs",
    name: "detailImgs",
    component: detailImgs,
    meta: {
      title: "图片列表"
    }
  },
  {
    path: "/aboutUs/AboutXz",
    name: "AboutXz",
    component: AboutXz,
    meta: {
      title: "小猪介绍"
    }
  },
  {
    path: "/aboutUs/Underage",
    name: "Underage",
    component: Underage,
    meta: {
      title: "未成年人隐私政策"
    }
  },
  {
    path: "/aboutUs/TermsOfService",
    name: "TermsOfService",
    component: TermsOfService,
    meta: {
      title: "服务协议"
    }
  },
  {
    path: "/aboutUs/ticketNotice",
    name: "ticketNotice",
    component: ticketNotice,
    meta: {
      title: "预售期临时调整公告"
    }
  },
  {
    path: "/aboutUs/PrivacyPolicy",
    name: "privacyPolicy",
    component: privacyPolicy,
    meta: {
      title: "隐私协议"
    }
  },
  {
    path: "/aboutUs/IntellectualProperty",
    name: "IntellectualProperty",
    component: intellectualProperty,
    meta: {
      title: "版权声明"
    }
  },
  {
    path: "/aboutUs/CheckInRule",
    name: "CheckInRule",
    component: CheckInRule,
    meta: {
      title: "房客规则"
    }
  },
  {
    path: "/Disclaimer",
    name: "Disclaimer",
    component: Disclaimer,
    meta: {
      title: "免责声明"
    }
  },
  {
    path: "/aboutUs/CommentRule",
    name: "CommentRule",
    component: CommentRule,
    meta: {
      title: "点评发布规则"
    }
  },
  {
    path: "/aboutUs/BusinessOperation",
    name: "BusinessOperation",
    component: BusinessOperation,
    meta: {
      title: "小猪酒店商家经营规则"
    }
  },
  {
    path: "/aboutUs/DisputeSettlement",
    name: "DisputeSettlement",
    component: DisputeSettlement,
    meta: {
      title: "小猪酒店商家经营规则"
    }
  },

  {
    path: "/autoTest",
    name: "autoTest",
    component: autoTest,
    meta: {
      title: "自动化测试"
    }
  },
  {
    path: "/roc/story",
    name: "story",
    component: story,
    meta: {
      title: "故事页"
    }
  },
  {
    path: "/highQualityList",
    name: "highQualityList",
    component: highQualityList,
    meta: {
      title: "榜单"
    }
  },
  {
    path: "/roc/brand",
    name: "brand",
    component: brand,
    meta: {
      title: "品牌页"
    }
  },
  {
    path: "/roc/travel",
    name: "travel",
    component: travel,
    meta: {
      title: "商旅介绍页"
    }
  },
  {
    path: "/officelineService/index",
    name: "officeLineIndex",
    component: officeLineIndex,
    meta: {
      title: "线下服务中心"
    }
  },
  {
    path: "/officelineService/indexOwn",
    name: "officeLineIndexOwn",
    component: officeLineIndexOwn,
    meta: {
      title: "线下服务中心"
    }
  },
  {
    path: "/officelineService/allSites",
    name: "allSites",
    component: allSites,
    meta: {
      title: "服务中心"
    }
  },
  {
    path: "/officelineService/siteDetail",
    name: "siteDetail",
    component: siteDetail,
    meta: {
      title: "站点详情"
    }
  },
  {
    path: "/officelineService/siteMap",
    name: "siteMap",
    component: siteMap,
    meta: {
      title: "站点位置"
    }
  },
  {
    path: "/officelineService/serviceIntroduce",
    name: "serviceIntroduce",
    component: serviceIntroduce,
    meta: {
      title: "服务介绍"
    }
  },
  {
    path: "/officelineService/serviceIndex",
    name: "serviceIndex",
    component: serviceIndex,
    meta: {
      title: "服务介绍"
    }
  },
  {
    path: "/officelineService/article",
    name: "article",
    component: article,
    meta: {
      title: "服务条款"
    }
  },
  {
    path: "/officelineService/citySites",
    name: "citySites",
    component: citySites,
    meta: {
      title: "服务中心"
    }
  },
  {
    path: "/roc/inn",
    name: "inn",
    component: inn,
    meta: {
      title: "景区客栈"
    }
  },
  {
    path: "/agreement/vip",
    name: "vip",
    component: vip,
    meta: {
      title: "小猪超级会员服务协议"
    }
  },
  {
    path: "/appUP/",
    name: "appUp",
    component: appUp,
    meta: {
      title: "小猪-短租民宿预订首选,独一无二的社交住宿体验"
    }
  },
  {
    path: "/appDownload/",
    name: "appDownload",
    component: appDownload,
    meta: {
      title: "小猪-短租民宿预订首选,独一无二的社交住宿体验"
    }
  },
  {
    path: "/member/intro",
    name: "intro",
    component: memberIntroduce,
    meta: {
      title: "小猪超级会员中心"
    }
  },
  {
    path: "/member/memberRights",
    name: "memberRights",
    component: memberRights,
    meta: {
      title: "小猪会员权益详解"
    }
  },
  {
    path: "/member/takeNotes",
    name: "takeNotes",
    component: takeNotes,
    meta: {
      title: "会员开通记录"
    }
  },
  {
    path: "/member/about",
    name: "aboutvip",
    component: aboutvip,
    meta: {
      title: "小猪超级会员介绍"
    }
  },
  {
    path: "/agreement",
    name: "agreement",
    component: agreement,
    meta: {
      title: "会员协议"
    }
  },
  {
    path: "/robot",
    name: "robot",
    component: chatRobot,
    meta: {
      title: "订房小秘书"
    }
  },
  {
    path: "/imMarker",
    name: "imMarker",
    component: imMarker,
    meta: {
      title: "消息"
    }
  },
  {
    path: "/receiveMethod",
    name: "receiveMethod",
    component: receiveMethod,
    meta: {
      title: "领取方法"
    }
  },
  {
    path: "/fdSaleRule",
    name: "fdSaleRule",
    component: fdSaleRule,
    meta: {
      title: "房东直销规则"
    }
  },
  {
    path: "/recall",
    name: "recall",
    component: recall,
    meta: {
      title: "向您推荐"
    }
  },
  {
    path: "/insurance/accident",
    name: "pingAn",
    component: pingAn,
    meta: {
      title: "住宿旅行意外险告知书"
    }
  },
  {
    path: "/insurance/landlordPropertySafe",
    name: "landlordPingAn",
    component: landlordPingAn,
    meta: {
      title: "房东财产综合保险"
    }
  },
  {
    path: "/insurance/huataiLandlordPropertySafe",
    name: "landlordHuaTai",
    component: landlordHuaTai,
    meta: {
      title: "房东财产综合保险"
    }
  },
  {
    path: "/insurance/accidentalInjury",
    name: "accidentalInjury",
    component: accidentalInjury,
    meta: {
      title: "平安产险意外伤害保险（互联网版）条款"
    }
  },
  {
    path: "/insurance/familyProperty",
    name: "familyProperty",
    component: familyProperty,
    meta: {
      title: "平安家庭财产保险条款"
    }
  },
  {
    path: "/insurance/landlordResponsibility",
    name: "landlordResponsibility",
    component: landlordResponsibility,
    meta: {
      title: "平安附加出租人责任保险条款"
    }
  },
  {
    path: "/insurance/housePropertyLoss",
    name: "housePropertyLoss",
    component: housePropertyLoss,
    meta: {
      title: "平安附加出租屋财产过失损坏保险条款"
    }
  },
  {
    path: "/insurance/tubeExplosion",
    name: "tubeExplosion",
    component: tubeExplosion,
    meta: {
      title: "平安附加水暖管爆裂损失保险条款"
    }
  },
  {
    path: "/insurance/propertyTheft",
    name: "propertyTheft",
    component: propertyTheft,
    meta: {
      title: "平安附加家庭财产盗抢损失保险条款"
    }
  },
  {
    path: "/insurance/reputationLoss",
    name: "reputationLoss",
    component: reputationLoss,
    meta: {
      title: "平安附加出租房声誉损失津贴保险条款"
    }
  },
  {
    path: "/insurance/rentLoss",
    name: "rentLoss",
    component: rentLoss,
    meta: {
      title: "平安附加租金损失保险条款"
    }
  },
  {
    path: "/insurance/aiTreatment",
    name: "aiTreatment",
    component: aiTreatment,
    meta: {
      title: "J003平安附加意外伤害医疗保险"
    }
  },
  {
    path: "/insurance/aiHospitalizationAllowance",
    name: "aiHospitalizationAllowance",
    component: aiHospitalizationAllowance,
    meta: {
      title: "J092平安附加意外伤害住院津贴保险"
    }
  },
  {
    path: "/insurance/accidentalDeath",
    name: "accidentalDeath",
    component: accidentalDeath,
    meta: {
      title: "Y003平安附加交通工具意外身故保险"
    }
  },
  /* 房东房客协商退款 */
  {
    path: "/order/consultRefund",
    name: "consultRefund",
    component: consultRefund,
    meta: {
      title: "申请退款"
    }
  },
  /* 退款详情 */
  {
    path: "/order/refundDetail",
    name: "refundDetail",
    component: refundDetail,
    meta: {
      title: "申请退款"
    }
  },
  /* 房客退订规则 */
  {
    path: "/refundRules/:pageSource?/:luId?",
    name: "refundRules",
    component: refundRules,
    meta: {
      title: "房客退订规则"
    }
  },
  /* 房客退订规则-展示 */
  {
    path: "/refundRulesShow/:pageSource?/:luId?",
    name: "refundRulesShow",
    component: refundRulesShow,
    meta: {
      title: "房客退订规则"
    }
  },

  /* 退款进度 */
  {
    path: "/refund",
    name: "refund",
    component: refund,
    meta: {
      title: "退款进度"
    }
  },
  /** chatV3 */
  {
    path: "/chatV3",
    name: "chatV3",
    component: chatV3,
    meta: {
      title: "消息"
    }
  },
  /* 商旅补开发票 */
  {
    path: "/busitravel/billList",
    name: "billList",
    component: billList,
    meta: {
      title: "选择订单开发票"
    }
  },
  {
    path: "/busitravel/billInfo",
    name: "billInfo",
    component: billInfo,
    meta: {
      title: "小猪商旅"
    }
  },
  {
    path: "/busitravel/billHeaderList",
    name: "billHeader",
    component: billHeaderList,
    meta: {
      title: "小猪商旅"
    }
  },
  {
    path: "/busitravel/billHeader",
    name: "billHeader",
    component: billHeader,
    meta: {
      title: "小猪商旅"
    }
  },
  {
    path: "/busitravel/addressList",
    name: "addressList",
    component: addressList,
    meta: {
      title: "小猪商旅"
    }
  },
  {
    path: "/busitravel/adressInfo",
    name: "adressInfo",
    component: adressInfo,
    meta: {
      title: "小猪商旅"
    }
  },
  {
    path: "/busitravel/billType",
    name: "billType",
    component: billType,
    meta: {
      title: "小猪商旅"
    }
  },
  {
    path: "/busitravel/nestBillLogin",
    name: "nestBillLogin",
    component: nestBillLogin,
    meta: {
      title: "小猪-登录"
    }
  },

  /* 邀请/被邀请 */
  {
    path: "/invite",
    name: "invite",
    component: invite,
    meta: {
      title: "邀请好友"
    }
  },
  {
    path: "/inviteList",
    name: "inviteList",
    component: inviteList,
    meta: {
      title: "邀请好友"
    }
  },
  {
    path: "/accept",
    name: "accept",
    component: accept,
    meta: {
      title: "小猪@你并送你300元住宿基金"
    }
  },
  {
    path: "/houseState/",
    name: "houseState",
    component: houseState,
    meta: {
      title: "「小猪房态助手」说明"
    }
  },
  /* app桥页 */
  {
    path: "/bridgePage",
    name: "bridgePage",
    component: bridgePage,
    meta: {
      title: "小猪-桥页"
    }
  },
  {
    path: "/landlord/promotionSheet",
    name: "promotionSheet",
    component: promotionSheet,
    meta: {
      title: "快捷调价"
    }
  },
  {
    path: "/landlord/priceList",
    name: "priceList",
    component: priceList,
    meta: {
      title: "跟价记录"
    }
  },
  {
    path: "/landlord/loseDetail",
    name: "loseDetail",
    component: loseDetail,
    meta: {
      title: "跟价详情"
    }
  },
  // 超棒房东相关
  {
    path: "/bestLandlord",
    name: "BestLandlord",
    component: BestLandlord,
    meta: {
      title: "超棒房东"
    }
  },
  {
    path: "/bestLandlord/details",
    name: "BestLandlordDetails",
    component: BestLandlordDetails,
    meta: {
      title: "了解超棒房东"
    }
  },
  {
    path: "/bestLandlord/canvote",
    name: "HistoryCantVote",
    component: HistoryCantVote,
    meta: {
      title: "第14期“超棒房东”评选进行中，快来参与吧！"
    }
  },
  // {
  //     path: '/bestLandlord/landlordDesc',
  //     name: 'HistoryLandlord',
  //     component: HistoryLandlord,
  //     meta: {
  //         title: '超棒房东全新改版'
  //     }
  // },
  {
    path: "/bestLandlord/historyHonor",
    name: "HistoryHonor",
    component: HistoryHonor,
    meta: {
      title: "我的历史荣誉"
    }
  },
  {
    path: "/bestLandlord/landlordThreshold",
    name: "LandlordThreshold",
    component: LandlordThreshold,
    meta: {
      title: "第14期“超棒房东”评选进行中,快来参与吧"
    }
  },
  {
    path: "/bestLandlord/landlordVote",
    name: "LandlordVote",
    component: LandlordVote,
    meta: {
      title: "第14期“超棒房东”评选进行中，快来参与吧！"
    }
  },
  {
    path: "/landlordTask",
    name: "landlordTask",
    component: landlordTask,
    meta: {
      title: "房东任务"
    }
  },
  {
    path: "/billV6Detail",
    name: "billV6Detail",
    component: billV6Detail,
    meta: {
      title: "发票详情"
    }
  },
  {
    path: "/manage/index",
    name: "manageIndex",
    component: manageIndex,
    meta: {
      title: ""
    }
  },
  {
    path: "/manage/indexV2",
    name: "manageIndexV2",
    component: manageIndexV2,
    meta: {
      title: "门店经营数据"
    }
  },
  {
    path: "/manage/detail",
    name: "manageDetail",
    component: manageDetail,
    meta: {
      title: "房源服务数据"
    }
  },
  {
    path: "/agreementList",
    name: "agreementList",
    component: agreementList,
    meta: {
      title: "网站协议"
    }
  },
  {
    path: "/bargin",
    name: "bargin",
    component: bargin,
    meta: {
      title: "好友砍价返50元现金"
    }
  },
  {
    path: "/successBargain",
    name: "successBargain",
    component: successBargain,
    meta: {
      title: ""
    }
  },
  {
    path: "/jumpUrl",
    name: "jumpUrl",
    component: jumpUrl,
    meta: {
      title: "跳转中..."
    }
  },
  {
    path: "/promotion/my",
    name: "myHousePromotiom",
    component: myHousePromotiom,
    meta: {
      title: "我的推广"
    }
  },
  {
    path: "/promotion/description",
    name: "descriptionPromotiom",
    component: descriptionPromotiom,
    meta: {
      title: "房源推广通"
    }
  },
  {
    path: "/promotion/create",
    name: "createPromotiom",
    component: createPromotiom,
    meta: {
      title: "房源推广"
    }
  },
  {
    path: "/promotion/history",
    name: "historyPromotiom",
    component: historyPromotiom,
    meta: {
      title: "历史推广"
    }
  },
  {
    path: "/promotion/question",
    name: "questionPromotiom",
    component: questionPromotiom,
    meta: {
      title: "常见问题"
    }
  },
  {
    path: "/promotion/questionItem",
    name: "questionItemPromotiom",
    component: questionItemPromotiom,
    meta: {
      title: "常见问题"
    }
  },
  {
    path: "/promotion/agree",
    name: "agreePromotiom",
    component: agreePromotiom,
    meta: {
      title: "房源推广服务协议"
    }
  },
  {
    path: "/test",
    name: "test",
    component: test,
    meta: {
      title: "跳转中..."
    }
  },
  /* 学生邀请 */
  {
    path: "/invite/student",
    name: "inviteStudent",
    component: inviteStudent,
    meta: {
      title: "邀友注册免费领100元大礼包"
    }
  },
  {
    path: "/invite/studentList",
    name: "studentList",
    component: studentList,
    meta: {
      title: "邀请列表"
    }
  },
  /* 房东活动 */
  {
    path: "/landlord/list",
    name: "landlordList",
    component: landlordList,
    meta: {
      title: "活动报名"
    }
  },
  {
    path: "/landlord/detail",
    name: "landlordDetail",
    component: landlordDetail,
    meta: {
      title: "活动详情"
    }
  },
  {
    path: "/landlord/edit",
    name: "landlordEdit",
    component: landlordEdit,
    meta: {
      title: "编辑"
    }
  },
  {
    path: "/landlord/notice",
    name: "landlordNotice",
    component: landlordNotice,
    meta: {
      title: "注意事项"
    }
  },
  {
    path: "/landlord/history",
    name: "landlordHistory",
    component: landlordHistory,
    meta: {
      title: "往期活动"
    }
  },
  {
    path: "/landlord/signup",
    name: "landlordSignup",
    component: landlordSignup,
    meta: {
      title: "活动详情"
    }
  },
  {
    path: "/landlord/record",
    name: "landlordRecord",
    component: landlordRecord,
    meta: {
      title: "报名记录"
    }
  },
  {
    path: "/toApp/commentComplete(/)?*",
    name: "commentComplete",
    component: commentComplete,
    meta: {
      title: "点评完成"
    }
  },
  {
    path: "/toApp/zhiChiGuideUpgrade(/)?*",
    name: "zhiChiGuideUpgrade",
    component: zhiChiGuideUpgrade,
    meta: {
      title: "提示"
    }
  },
  {
    path: "/myInfo/selectRealName",
    name: "selectRealName",
    component: selectRealName,
    meta: {
      title: "身份认证"
    }
  },
  {
    path: "/aboutUs/cashPolicy",
    name: "cashPolicy",
    component: cashPolicy,
    meta: {
      title: "押金担保服务协议"
    }
  },
  {
    path: "/selectPerson",
    name: "selectPerson",
    component: selectPerson,
    meta: {
      title: "绑定微信支付电商收付通"
    }
  },
  {
    path: "/wxBusiness",
    name: "wxBusiness",
    component: wxBusiness,
    meta: {
      title: "绑定微信支付电商收付通"
    }
  },
  {
    path: "/wxPerson",
    name: "wxPerson",
    component: wxPerson,
    meta: {
      title: "绑定微信支付电商收付通"
    }
  },
  {
    path: "/wxAccount",
    name: "wxAccount",
    component: wxAccount,
    meta: {
      title: "绑定微信支付电商收付通"
    }
  },
  {
    path: "/enterprisePay",
    name: "enterprisePay",
    component: enterprisePay,
    meta: {
      title: "绑定微信支付电商收付通"
    }
  },
  {
    path: "/wxCheck",
    name: "wxCheck",
    component: wxCheck,
    meta: {
      title: "资料校验中"
    }
  },
  {
    path: "/checkStatus",
    name: "checkStatus",
    component: checkStatus,
    meta: {
      title: "绑定微信支付电商收付通"
    }
  },
  {
    path: "/checkWxTwo",
    name: "checkWxTwo",
    component: checkWxTwo,
    meta: {
      title: "绑定微信支付电商收付通"
    }
  },
  {
    path: "/checkResult",
    name: "checkResult",
    component: checkResult,
    meta: {
      title: "绑定微信支付电商收付通"
    }
  },
  {
    path: "/cancelReason",
    name: "cancelReason",
    component: cancelReason,
    meta: {
      title: "请选择取消原因"
    }
  },
  {
    path: "/newCancelOrder",
    name: "newCancelOrder",
    component: newCancelOrder,
    meta: {
      title: "取消订单"
    }
  },
  {
    path: "/appRule",
    name: "appRule",
    component: appRule,
    meta: {
      title: "房东规则"
    }
  },
  {
    path: "/appRuleImg",
    name: "appRuleImg",
    component: appRuleImg,
    meta: {
      title: "小猪"
    }
  },
  /**
   * ➕ 新的路由 ⬆⬆⬆
   * 404 一定要保持在最后面
   */
  {
    path: "/autoIm",
    name: "autoIm",
    component: autoIm,
    meta: {
      title: "自动回复小助手"
    }
  },
  {
    path: "/autoReply/:landlordId/:luId",
    name: "autoReply",
    component: autoReply,
    meta: {
      title: "全部自动回复"
    }
  },
  {
    path: "/helpIm",
    name: "helpIm",
    component: helpIm,
    meta: {
      title: "房态小助手"
    }
  },
  {
    path: "/landlordService",
    name: "landlordService",
    component: landlordService,
    meta: {
      title: "入住指南"
    }
  },
  {
    path: "/cashBack",
    name: "cashBack",
    component: cashBack,
    meta: {
      title: "返现奖励"
    }
  },
  {
    path: "/shareCoupon/:state",
    name: "shareCoupon",
    component: shareCoupon,
    meta: {
      title: "分享领券"
    }
  },
  {
    path: "/houseMove/index",
    name: "houseMove",
    component: houseMove,
    meta: {
      title: "一键搬房"
    }
  },
  {
    path: "/houseMove/rule",
    name: "houseMoveRule",
    component: houseMoveRule,
    meta: {
      title: "一键搬房"
    }
  },
  {
    path: "/otherInfo",
    name: "otherInfo",
    component: otherInfo,
    meta: {
      title: "其他信息",
      auth: false
    }
  },
  {
    path: "/jurisdiction",
    name: "jurisdiction",
    component: jurisdiction,
    meta: {
      title: "管辖机构",
      auth: false
    }
  },
  {
    path: "/satisfaction",
    name: "satisfaction",
    component: satisfaction,
    meta: {
      title: "匿名评价"
    }
  },
  {
    path: "/noteDetail",
    name: "noteDetail",
    component: noteDetail,
    meta: {
      title: "笔记详情",
      auth: false
    }
  },
  {
    path: "/orderPrint",
    name: "orderPrint",
    component: orderPrint,
    meta: {
      title: "打印订单",
      auth: false
    }
  },
  {
    path: "/openApp",
    name: "openApp",
    component: openApp,
    meta: {
      title: "打开App",
      auth: false
    }
  },
  {
    path: "/bargainMall",
    name: "bargainMall",
    component: bargainMall,
    meta: {
      title: "分享免费拿"
    }
  },
  {
    path: "/testShare",
    name: "testShare",
    component: testShare,
    meta: {
      title: "分享测试"
    }
  },
  {
    path: "/aboutUs/copyrights",
    name: "copyrights",
    component: copyrights,
    meta: {
      title: "房客入住安全须知"
    }
  },
  {
    path: "/app/serviceIntro",
    name: "serviceIntro",
    component: serviceIntro,
    meta: {
      title: "客服介绍"
    }
  },
  {
    path: "/cookie",
    name: "cookie",
    component: cookie,
    meta: {
      title: "小猪短租",
      auth: false
    }
  },
  {
    path: "/hotelDetail",
    name: "hotelDetail",
    component: hotelDetail,
    meta: {
      title: "酒店详情"
    }
  },
  // 协议
  {
    path: "/bussinessOperation",
    name: "bussinessOperation",
    component: bussinessOperation,
    meta: {
      title: "小猪酒店商家经营规则"
    }
  },
  {
    path: "/aboutUs/carefreeZhongAnInsurance",
    name: "carefreeZhongAnInsurance",
    component: carefreeZhongAnInsurance,
    meta: {
      title: "众安取消险"
    }
  },
  {
    path: "/aboutUs/cashPledgeFd",
    name: "cashPledgeFd",
    component: cashPledgeFd,
    meta: {
      title: "在线押金"
    }
  },
  {
    path: "/aboutUs/cashPledgeFk",
    name: "cashPledgeFk",
    component: cashPledgeFk,
    meta: {
      title: "在线押金"
    }
  },
  {
    path: "/aboutUs/cleanServiceAccountRule",
    name: "cleanServiceAccountRule",
    component: cleanServiceAccountRule,
    meta: {
      title: "保洁代金券"
    }
  },
  {
    path: "/commentRule",
    name: "commentRule",
    component: commentRule,
    meta: {
      title: "点评规则"
    }
  },
  {
    path: "/aboutUs/couponRule",
    name: "couponRule",
    component: couponRule,
    meta: {
      title: "代金券"
    }
  },
  {
    path: "/aboutUs/disclaimer",
    name: "disclaimer",
    component: disclaimer,
    meta: {
      title: "免责声明"
    }
  },
  {
    path: "/disputeSettlemant",
    name: "disputeSettlemant",
    component: disputeSettlemant,
    meta: {
      title: "小猪酒店特定争议处理标准"
    }
  },
  {
    path: "/aboutUs/familyInsurance",
    name: "familyInsurance",
    component: familyInsurance,
    meta: {
      title: "众安家庭财产保险"
    }
  },
  {
    path: "/aboutUs/goodLandlordRule",
    name: "goodLandlordRule",
    component: goodLandlordRule,
    meta: {
      title: "超棒房东规则说明"
    }
  },
  {
    path: "/aboutUs/integral",
    name: "integral",
    component: integral,
    meta: {
      title: "积分规则"
    }
  },
  {
    path: "/aboutUs/landlordDetailRule",
    name: "landlordDetailRule",
    component: landlordDetailRule,
    meta: {
      title: "房源上线标准"
    }
  },
  {
    path: "/aboutUs/landlordManageRule",
    name: "landlordManageRule",
    component: landlordManageRule,
    meta: {
      title: "房东经营行为管理规范"
    }
  },
  {
    path: "/aboutUs/landlordRules",
    name: "landlordRules",
    component: landlordRules,
    meta: {
      title: "房东规则"
    }
  },
  {
    path: "/aboutUs/persionLandlordRule",
    name: "persionLandlordRule",
    component: persionLandlordRule,
    meta: {
      title: "个人房东”认证规则"
    }
  },
  {
    path: "/priveayPolicy",
    name: "priveayPolicy",
    component: priveayPolicy,
    meta: {
      title: "隐私保护声明"
    }
  },
  {
    path: "/aboutUs/tailKangFamilyInsurance",
    name: "tailKangFamilyInsurance",
    component: tailKangFamilyInsurance,
    meta: {
      title: "泰康家庭财产保险"
    }
  },
  {
    path: "/TermsOfService",
    name: "termOfService",
    component: termOfService,
    meta: {
      title: "服务协议"
    }
  },
  {
    path: "/aboutUs/aboutUs",
    name: "aboutUs",
    component: aboutUsPolicy,
    meta: {
      title: "关于我们"
    }
  },
  {
    path: "/aboutUs/toBeLandlord",
    name: "toBeLandlord",
    component: toBeLandlord,
    meta: {
      title: "为什么要在小猪上当房东"
    }
  },
  {
    path: "/aboutUs/cleanServiceRule",
    name: "cleanServiceRule",
    component: cleanServiceRule,
    meta: {
      title: "保洁服务协议"
    }
  },
  /**
   * ➕ 新的路由 ⬆⬆⬆
   * 404 一定要保持在最后面
   */
  {
    path: "*",
    name: "404",
    component: notFound
  },
];



// WEBPACK FOOTER //
// ./src/config/routes.js